import { DropdownControl, FormCol, useScopedSelector } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Contract } from '../../../../../../interfaces/Contract';
import { NewMessagePageState } from '../../../../../../interfaces/NewMessagePageState';
import { changeContract } from '../../../../NewMessagePage.actions';
import { StyledText } from '../../../../NewMessagePage.styles';
import useDefaultValue from '../../../useDefaultValue';

export interface ContractsControlProps { }

const ContractsControl: FC<ContractsControlProps> = () => {
  const { t } = useTranslation('NewMessagePage');
  const dispatch = useDispatch();
  const dispatchChangeContract = () => dispatch(changeContract());
  const contracts = useScopedSelector((state: NewMessagePageState) => state.contracts || []);
  const contractOptions = useMemo(() => contracts.map((c) => ({
    label: c.description,
    value: c,
    key: ['productCode', 'number'],
  })), [contracts]);

  const defaultValue = useDefaultValue('defaultcontract', contractOptions, true, 'productCode');

  return (
    <FormCol label={t('contract')}>
      <StyledText>
        <DropdownControl<Contract>
          required
          name="contract"
          aria-label={t('contract')}
          options={contractOptions}
          onValueChange={() => dispatchChangeContract()}
          defaultValue={defaultValue}
        />
      </StyledText>
    </FormCol>
  );
};
export default ContractsControl;
